var exports = {
  "UX": "PlutoniumUpsell.module__upsell___ZVZ4Yj",
  "Kk": "PlutoniumUpsell.module__icon___ZVZ4Yj",
  "Qs": "PlutoniumUpsell.module__content___ZVZ4Yj",
  "Qq": "PlutoniumUpsell.module__text___ZVZ4Yj",
  "o1": "PlutoniumUpsell.module__actions___ZVZ4Yj",
  "R3": "PlutoniumUpsell.module__dismissLink___ZVZ4Yj",
};

module.exports = exports;
